// 解析IP数据
function transformDataFromIPapi(data, ipGeoSource, t, mapLanguage) {
    if (data.error) {
        throw new Error(data.reason);
    }

    const baseData = {
        country_name: data.country_name || "",
        country_code: data.country === 'N/A' ? '' : data.country,
        region: data.region || "",
        city: data.city || "",
        latitude: data.latitude || "",
        longitude: data.longitude || "",
        isp: data.org || "",
        asn: data.asn || "",
        asnlink: data.asn ? `https://bgp.tools/as/${data.asn}` : false,
        mapUrl: data.latitude && data.longitude ? `/api/map?latitude=${data.latitude}&longitude=${data.longitude}&language=${mapLanguage}` : "",
        mapUrl_dark: data.latitude && data.longitude ? `/api/map?latitude=${data.latitude}&longitude=${data.longitude}&language=${mapLanguage}&CanvasMode=Dark` : ""
    };

    if (ipGeoSource === 0) {
        const proxyDetails = extractProxyDetails(data.proxyDetect, t);
        return {
            ...baseData,
            ...proxyDetails,
        };
    }

    return baseData;
};

// Transform quality analysis data from the unified API
function transformQualityAnalysisData(data, t) {
    if (data.error) {
        throw new Error(data.error);
    }

    const analysis = data.analysis || {};
    
    return {
        ip: data.ip,
        type: transformConnectionType(analysis.type, t),
        proxy: transformProxyStatus(analysis.proxy, t),
        nativeness: transformNativeness(analysis.nativeness, t),
        quality: {
            score: analysis.quality?.score || 0,
            level: transformQualityLevel(analysis.quality?.level, t),
            confidence: transformConfidenceLevel(analysis.quality?.confidence, t)
        },
        providers: data.providers || [],
        consensus: data.provider_consensus || {},
        raw_data: data.individual_results || {},
        errors: data.errors || {}
    };
}

// 解析代理数据
function extractProxyDetails(proxyDetect = {}, t) {
    const isProxy = determineIsProxy(proxyDetect, t);
    const type = determineType(proxyDetect, t);
    const qualityScore = proxyDetect.risk === 'unknown' ? 'unknown' : proxyDetect.risk === 'sign_in_required'? 'sign_in_required' : (100 - proxyDetect.risk);
    const proxyProtocol = determineProtocol(proxyDetect, t);
    const proxyOperator = proxyDetect.operator || "";

    return { isProxy, type, qualityScore, proxyProtocol, proxyOperator };
}

// 判断是否代理
function determineIsProxy(proxyDetect, t) {
    if (proxyDetect.proxy === 'yes' && proxyDetect.protocol !== 'unknown') {
        return t('ipInfos.proxyDetect.yes');
    } else if (proxyDetect.proxy === 'yes') {
        return t('ipInfos.proxyDetect.maybe');
    } else if (proxyDetect.proxy === 'no') {
        return t('ipInfos.proxyDetect.no');
    } else if (proxyDetect.proxy === 'sign_in_required') {
        return 'sign_in_required';
    } else {
        return t('ipInfos.proxyDetect.unknownProxyType');
    }
}

// 判断代理类型
function determineType(proxyDetect, t) {
    switch (proxyDetect.type) {
        case 'Business':
            return t('ipInfos.proxyDetect.type.Business');
        case 'Residential':
            return t('ipInfos.proxyDetect.type.Residential');
        case 'Wireless':
            return t('ipInfos.proxyDetect.type.Wireless');
        case 'Hosting':
            return t('ipInfos.proxyDetect.type.Hosting');
        case 'VPN':
            if (proxyDetect.protocol === 'unknown') {
                return t('ipInfos.proxyDetect.type.Hosting');
            }
        default:
            return proxyDetect.type || t('ipInfos.proxyDetect.type.unknownType');
    }
}

// 判断代理协议
function determineProtocol(proxyDetect, t) {
    if (proxyDetect.protocol === 'unknown' || !proxyDetect.protocol) {
        return t('ipInfos.proxyDetect.unknownProtocol');
    } else {
        return proxyDetect.protocol;
    }
}

// Transform connection type for display
function transformConnectionType(type, t) {
    if (!type || type === 'Unknown') {
        return t('ipInfos.qualityAnalysis.type.unknown');
    }
    
    const typeMap = {
        'Residential': t('ipInfos.qualityAnalysis.type.residential'),
        'Commercial': t('ipInfos.qualityAnalysis.type.business'),
        'Data Center': t('ipInfos.qualityAnalysis.type.dataCenter'),
        'Educational': t('ipInfos.qualityAnalysis.type.educational'),
        'Government': t('ipInfos.qualityAnalysis.type.government'),
        'Military': t('ipInfos.qualityAnalysis.type.military'),
        'ISP': t('ipInfos.qualityAnalysis.type.isp'),
        'Mobile': t('ipInfos.qualityAnalysis.type.mobile'),
        'Organization': t('ipInfos.qualityAnalysis.type.organization'),
        'CDN': t('ipInfos.qualityAnalysis.type.cdn'),
        'Library': t('ipInfos.qualityAnalysis.type.library'),
        'Bot/Crawler': t('ipInfos.qualityAnalysis.type.bot')
    };
    
    return typeMap[type] || type;
}

// Transform proxy status for display
function transformProxyStatus(status, t) {
    if (!status || status === 'Unknown') {
        return t('ipInfos.qualityAnalysis.proxy.unknown');
    }
    
    const statusMap = {
        'Clean IP': t('ipInfos.qualityAnalysis.proxy.clean'),
        'Low Risk IP': t('ipInfos.qualityAnalysis.proxy.lowRisk'),
        'Potentially Risky IP': t('ipInfos.qualityAnalysis.proxy.potentiallyRisky'),
        'Suspicious IP': t('ipInfos.qualityAnalysis.proxy.suspicious'),
        'High Risk IP': t('ipInfos.qualityAnalysis.proxy.highRisk'),
        'Possible Proxy/VPN': t('ipInfos.qualityAnalysis.proxy.possibleProxy'),
        'Likely Proxy/VPN': t('ipInfos.qualityAnalysis.proxy.likelyProxy'),
        'High Risk Proxy/VPN': t('ipInfos.qualityAnalysis.proxy.highRiskProxy')
    };
    
    return statusMap[status] || status;
}

// Transform nativeness for display
function transformNativeness(nativeness, t) {
    if (!nativeness || nativeness === 'Unknown') {
        return t('ipInfos.qualityAnalysis.nativeness.unknown');
    }
    
    const nativenessMap = {
        'Native': t('ipInfos.qualityAnalysis.nativeness.native'),
        'Non-native': t('ipInfos.qualityAnalysis.nativeness.nonNative')
    };
    
    return nativenessMap[nativeness] || nativeness;
}

// Transform quality level for display
function transformQualityLevel(level, t) {
    if (!level || level === 'Unknown') {
        return t('ipInfos.qualityAnalysis.quality.unknown');
    }
    
    const levelMap = {
        'Excellent': t('ipInfos.qualityAnalysis.quality.excellent'),
        'Good': t('ipInfos.qualityAnalysis.quality.good'),
        'Fair': t('ipInfos.qualityAnalysis.quality.fair'),
        'Poor': t('ipInfos.qualityAnalysis.quality.poor'),
        'Very Poor': t('ipInfos.qualityAnalysis.quality.veryPoor')
    };
    
    return levelMap[level] || level;
}

// Transform confidence level for display
function transformConfidenceLevel(confidence, t) {
    if (!confidence) {
        return t('ipInfos.qualityAnalysis.confidence.unknown');
    }
    
    const confidenceMap = {
        'High': t('ipInfos.qualityAnalysis.confidence.high'),
        'Medium': t('ipInfos.qualityAnalysis.confidence.medium'),
        'Low': t('ipInfos.qualityAnalysis.confidence.low')
    };
    
    return confidenceMap[confidence] || confidence;
}

export { 
    transformDataFromIPapi, 
    extractProxyDetails, 
    transformQualityAnalysisData,
    transformConnectionType,
    transformProxyStatus,
    transformNativeness,
    transformQualityLevel,
    transformConfidenceLevel 
};
